import { c as _c } from "react/compiler-runtime";
import { Box, Separator, Heading, HStack } from '@chakra-ui/react';
import MasonryGrid, { renderCardComponent } from '@src/components/sco/InvestorOutreachLP/components/blocks/MasonryGrid';
import SectionWrapper from '@src/components/sco/LayoutBlocks/SectionWrapper';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { processCardsData } from '@src/components/sco/utilities/cardUtils';
import React from 'react';
export const TestimonialsBlock = () => {
  const $ = _c(18);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  getBreakpointValue([false, false, true, false, false]);
  getBreakpointValue([true, true, false, false, false]);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const idsToRenderForMasonryGrid = ["sc4", "ohc1", "bc17", "sc6", "qc3", "bc19", "pc1", "sc9", "qc6", "bc5", "sc1", "pc2", "bc8", "bc7", "bc2", "bc3", "bc4"];
    const sortedCardsForMasonryGrid = processCardsData(idsToRenderForMasonryGrid);
    t0 = sortedCardsForMasonryGrid.map(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const masonryGridCardComponents = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Separator flex="1" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue(["xl", "2xl", "3xl"]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Heading color="colorPalette.fg" letterSpacing="wide" size={t2} textAlign="center" textTransform="uppercase">Testimonials</Heading>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Separator flex="1" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <HStack align="center" gap={10} justify="center" width="full">{t1}{t3}{t4}</HStack>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== getBreakpointValue) {
    t6 = getBreakpointValue(["3xl", "3xl", "3xl", "4xl", "4xl"]);
    $[9] = getBreakpointValue;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Box as="span" bgColor="red.fg/10" borderRadius="sm" color="colorPalette.fg" paddingX={1}>30,000</Box>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <Heading color="red.fg" size={t6} textAlign="center">{"Our platform has had over"}{" "}{t7}{" "}customer reviews (Avg 4.8 of 5)</Heading>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <MasonryGrid cards={masonryGridCardComponents} />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t5 || $[16] !== t8) {
    t10 = <SectionWrapper marginBottom={20} paddingY={10}>{t5}{t8}{t9}</SectionWrapper>;
    $[15] = t5;
    $[16] = t8;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
function _temp(data, index) {
  return renderCardComponent(data, index);
}